interface Props {
  children: JSX.Element | JSX.Element[];
  isPrint?: boolean;
  className?: string;
  onBlurCapture?: () => void;
}

/**
 * View invoice as paper format A4
 * tailwind does not offer cm unit --> style
 */
export default function InvoicePaperView({ children, isPrint, className, onBlurCapture }: Props) {
  if (isPrint) return <>{children}</>;
  return (
    <div
      onBlurCapture={onBlurCapture}
      style={{
        maxWidth: '21cm',
        minWidth: '21cm',
        minHeight: '29.7cm',
        margin: '1cm 20px 0 20px',
        background: 'white',
        border: '1px #D3D3D3 solid',
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
        padding: 0,
      }}
      className={`${className}`}
    >
      {children}
    </div>
  );
}
